<template>
  <div>
    <the-hero-section :title="title" :imgLink="imgLink" />
    <vertical-divider />
    <section id="equipos" class="extra-padding grey lighten-4">
      <v-container class="extra-padding pb-0" fluid>
        <v-row justify="center" mb="10">
          <v-col cols="12" md="8" class="mt-n8">
            <p class="text-justify font-weight-light">
              Para nosotros lo más importante es que nuestros clientes,
              particulares y empresas, queden completamente satisfechos con los
              servicios que brindamos. En Argecam contamos con personal
              calificado para realizar todas las obras viales.
            </p>
            <v-divider
              class="pt-1 mx-auto my-2 secondary"
              width="50"
            ></v-divider>
          </v-col>

          <v-col cols="12" md="10">
            <v-row justify="center">
              <v-col cols="12" md="4" v-for="e in equipamento" :key="e.i">
                <v-card max-width="400" class="mx-auto">
                  <v-carousel
                    continuous
                    :cycle="true"
                    :reverse="true"
                    show-arrows
                    height="300"
                  >
                    <v-carousel-item
                      v-for="link in e.links"
                      :key="link.i"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    >
                      <v-img
                        :src="require('@/assets/equipamento/' + link)"
                        max-height="300"
                        height="300"
                      >
                      </v-img>
                    </v-carousel-item>
                  </v-carousel>
                  <v-card-text class="pt-0">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            class="title primary--text text-uppercase"
                          >
                            {{ e.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mb-6"></v-divider>
                      <v-list-item v-for="item in e.items" :key="item.i">
                        <v-list-item-content class="my-0 py-0">
                          <p class="grey--text body-1">
                            <v-icon small color="primary">mdi-forward</v-icon>
                            {{ item }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section-contact :color="color" />
  </div>
</template>

<script>
export default {
  name: "Equipos",
  components: {
    TheHeroSection: () => import("@/components/TheHeroSection"),
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue"),
    SectionContact: () => import("@/views/Contact/Index.vue")
  },
  data: () => ({
    title: "Nuestros Equipos",
    imgLink: "section-equipos.jpeg",
    color: "primary white--text extra-padding",
    cycle: true,
    equipamento: {
      camiones: {
        title: "camiones",
        items: [
          "Volcadores 6x4 de 20mt3",
          "Volcadores 8x4 de 27mt3",
          "Regadores 4x2 de 10.000 litros",
          "Camión estación móvil"
        ],
        links: ["camiones/1.jpeg", "camiones/2.jpeg", "camiones/3.jpeg"]
      },
      equipos: {
        title: "equipos",
        items: [
          "Minicargadoras",
          "Excavadoras de orugas de 5 a 25Tn",
          "Excavadora Long reach Alcanza 16,5m",
          "Motoniveladoras de 150Hp",
          "Cargadora frontal de 3mt3",
          "Topadores de 200Hp",
          "Compactadores autopropulsados tambor pata de cabra / liso",
          "Tractor con rastra vial"
        ],
        links: ["equipos/1.jpeg", "equipos/2.jpeg", "equipos/3.jpeg"]
      },
      accesorios: {
        title: "accesorios",
        items: [
          "Martillos hidráulicos de 300 kg a 2500kg",
          "Camionetas d-c",
          "Camionetas c-s",
          "Tanques cisterna para combustible"
        ],
        links: ["accesorios/1.jpeg", "accesorios/2.jpeg", "accesorios/3.jpeg"]
      }
    }
  })
};
</script>

<style lang="sass" scoped></style>
